import { FlowDurationUnits, FlowFormCompletionWorkflowSignals } from 'flow-schema';

import { api } from 'common';

import { WaitForFormCompletionFormFields } from './FormFields.tsx';
import { waitForFormCompletionDocumentationMarkdown } from './documentation.ts';
import { type BlockConfigProps } from '../../types';

export const waitForFormCompletionConfig: BlockConfigProps<api.FlowDefinition.WaitForFormCompletionBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'waitForForm',
    defaultConfig: {
      signalName: FlowFormCompletionWorkflowSignals.FormSetCompleted,
      timeout: {
        value: 10,
        units: FlowDurationUnits.Minutes,
      },
    },
    configFields: {
      schema: api.FlowDefinition.WaitForFormCompletionBlockConfigSchema,
      FormFields: WaitForFormCompletionFormFields,
    },
    documentationMarkdown: waitForFormCompletionDocumentationMarkdown,
  };
